// src/components/art/ArtworkSection.jsx
import { useState } from "react";
import { FaUserGraduate, FaChalkboardTeacher } from "react-icons/fa";
import "../../styles/art/ArtworkSection.css";

const artworks = {
  student: [
    {
      id: 1,
      title: "Tranh Đẹp 8/2022",
      description:
        "Tranh đẹp của các bạn Học Viên trong trung tâm mỹ thuật Design24.",
      image: "/images/art/artworks/student1.webp",
    },
    {
      id: 2,
      title: "Tranh Đẹp Tháng 7/2023",
      description:
        "Tranh đẹp của các bạn Học Viên trong trung tâm mỹ thuật Design24.",
      image: "/images/art/artworks/student2.webp",
    },
    {
      id: 3,
      title: "Tranh Đẹp Tháng 4/2024",
      description:
        "Tranh đẹp của các bạn Học Viên trong trung tâm mỹ thuật Design24.",
      image: "/images/art/artworks/student3.webp",
    },
  ],
  teacher: [
    {
      id: 1,
      title: "CUỘC THI GIÁO VIÊN GIỎI DESIGN24 – CẤP ĐỘ CƠ BẢN",
      description:
        "Với tiêu chí đặt chất lượng giảng dạy lên hàng đầu, Mỹ thuật Design24 luôn tổ chức những khóa training ngắn hạn cho đội ngũ giáo viên và những cuộc thi lớn để nâng cao nghiệp vụ giảng dạy của các thầy cô tại trung tâm.",
      image: "/images/art/artworks/teacher1.webp",
    },
    {
      id: 2,
      title: "SẮC MÀU CỦA TƯƠNG LAI (COLOR OF THE FUTURE)",
      description:
        "Những bức tranh của các thầy cô Design24 về Sắc màu của tương lai: sắc màu của cuộc sống muôn màu muôn vẻ xung quanh chúng ta, về thiên nhiên, con người,  vẽ những ước mơ, khát vọng cháy bỏng hướng tới tương lai tốt đẹp hơn vì một xã hội văn minh, an toàn.",
      image: "/images/art/artworks/teacher2.webp",
    },
    {
      id: 3,
      title: "TRANH ĐẸP CỦA GIÁO VIÊN",
      description:
        "Hằng năm Design24 thường tổ chức Cuộc thi – triển lãm mỹ thuật dành cho các Giáo viên của tất cả các trung tâm vào dịp Chào mừng Ngày Nhà Giáo VN, nhằm tăng cường giao lưu, học hỏi trao đổi kinh nghiệm, tạo sự gắn kết giữa các trung tâm, nâng cao nghiệp vụ",
      image: "/images/art/artworks/teacher3.webp",
    },
  ],
};

function ArtworkSection() {
  const [activeTab, setActiveTab] = useState("student");

  return (
    <section className="artwork-section">
      <div className="artwork-section__container">
        <div className="artwork-section__header">
          <h2 className="artwork-section__title">TÁC PHẨM</h2>
          <div className="artwork-section__tabs">
            <button
              className={`artwork-tab ${
                activeTab === "student" ? "active" : ""
              }`}
              onClick={() => setActiveTab("student")}
            >
              <FaUserGraduate className="artwork-tab__icon" />
              <span>Tranh học viên</span>
            </button>

            <button
              className={`artwork-tab ${
                activeTab === "teacher" ? "active" : ""
              }`}
              onClick={() => setActiveTab("teacher")}
            >
              <FaChalkboardTeacher className="artwork-tab__icon" />
              <span>Tranh giáo viên</span>
            </button>
          </div>
        </div>

        <div className="artwork-section__grid">
          {artworks[activeTab].map((art) => (
            <div
              key={art.id}
              className="artwork-card"
            >
              <img
                src={art.image}
                alt={art.title}
                className="artwork-card__image"
              />
              <h3 className="artwork-card__title">{art.title}</h3>
              <p className="artwork-card__description">{art.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ArtworkSection;
